'use client';

import { useEffect, useState } from 'react';

import { universes, pricingToggles } from '@/data/universes';
import { useScrollReveal } from '@/hooks/useScrollReveal';
import { useNavScroll } from '@/hooks/useNavScroll';

import Navbar from '@/components/sections/Navbar';
import Hero from '@/components/sections/Hero';
import Features from '@/components/sections/Features';
import HowItWorks from '@/components/sections/HowItWorks';
import Testimonials from '@/components/sections/Testimonials';
import VideoShowcase from '@/components/sections/VideoShowcase';
import Pricing from '@/components/sections/Pricing';
import Faq from '@/components/sections/Faq';
import Footer from '@/components/sections/Footer';
import LegalModal from '@/components/sections/LegalModal';

export default function HomePage() {
  const [activeUniverse, setActiveUniverse] = useState(0);
  const [activePricing, setActivePricing] = useState(0);
  const [activeTestimonial, setActiveTestimonial] = useState(0);
  const [openFaq, setOpenFaq] = useState<number | null>(null);
  const [showLegal, setShowLegal] = useState(false);
  const [heroVisible, setHeroVisible] = useState(true);

  const navScrolled = useNavScroll();
  const { addRevealRef, resetRefs } = useScrollReveal(activeUniverse);

  const universe = universes[activeUniverse];

  // Réinitialise l'état d'affichage à chaque changement d'univers.
  useEffect(() => {
    setActiveTestimonial(0);
    setOpenFaq(null);
    setHeroVisible(false);
    const t = setTimeout(() => setHeroVisible(true), 50);
    return () => clearTimeout(t);
  }, [activeUniverse]);

  const handleUniverseChange = (idx: number) => {
    setActiveUniverse(idx);
    resetRefs();
  };

  return (
    <main className="bg-background overflow-x-hidden" style={{ fontFamily: "'Manrope', system-ui, sans-serif" }}>
      <Navbar
  navScrolled={navScrolled}
  universes={universes}
  activeUniverse={activeUniverse}
  onUniverseChange={handleUniverseChange}
/>

<Hero universe={universe} heroVisible={heroVisible} />

      <Features universe={universe} addRevealRef={addRevealRef} />

      <HowItWorks universe={universe} addRevealRef={addRevealRef} />

      <Testimonials
        universe={universe}
        activeTestimonial={activeTestimonial}
        onTestimonialChange={setActiveTestimonial}
        addRevealRef={addRevealRef}
      />

      <VideoShowcase universe={universe} addRevealRef={addRevealRef} />

      <Pricing
        universe={universe}
        pricingToggles={pricingToggles}
        activePricing={activePricing}
        onPricingChange={setActivePricing}
        addRevealRef={addRevealRef}
      />

      <Faq
        universe={universe}
        openFaq={openFaq}
        onToggleFaq={(i) => setOpenFaq(openFaq === i ? null : i)}
        addRevealRef={addRevealRef}
      />

      <Footer onShowLegal={() => setShowLegal(true)} />

      <LegalModal open={showLegal} onClose={() => setShowLegal(false)} />
    </main>
  );
}
